<div class="container">
  <main id="content" class="error-container" role="main">
    <div class="row justify-content-center">
      <div class="col-xl-4 col-md-6 col-10">
        <div class="error-container">
          <h1 class="error-code">404</h1>
          <p class="error-info">
            Oisann.. Det ser ut til at siden du prøvde å finne ikke eksisterer!
          </p>
          <p class="error-help mb">
            Hvis du mener det er feil, send en epost til pc&#64;sginfo.no.
          </p>
          <button mat-flat-button (click)="goToDashboard()">
            Gå tilbake til Min Side <mat-icon class="text-warning ml-xs">home</mat-icon>
          </button>          
        </div>
      </div>
    </div>
  </main>

  <footer class="page-footer">
    <img src="../../../assets/logo/sglogo_liggende_hvit.png" alt="" class="error-logo">
    {{currentDate | date:'yyyy'}} &copy; Crew. Stiftelsen Skjærgårds
  </footer>
</div>
